import { useState, useRef } from 'react'

import { useOnChangeEffect, useOnUnmountEffect } from 'admin/hooks'

const useHasChanged = (options, wait = 250) => {
  const { value, onChange, onBlur } = options || {}

  const [hasChanged, setHasChanged] = useState(false)
  const delayRef = useRef()

  useOnChangeEffect(() => {
    clearTimeout(delayRef.current)
    if (!hasChanged) {
      delayRef.current = setTimeout(() => setHasChanged(true), wait)
      return undefined
    }
  }, [value])

  useOnUnmountEffect(() => clearTimeout(delayRef.current))

  const handleBlur = (...args) => {
    if (onBlur) onBlur(...args)
  }
  const handleChange = (...args) => {
    if (onChange) onChange(...args)
  }
  return {
    hasChanged,
    onChange: handleChange,
    onBlur: handleBlur,
  }
}

export default useHasChanged
